<script>
import { mapState } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import SearchSuggestions from '../SearchSuggestions.vue';

export default {
    components: {
        SearchSuggestions,
    },
    directives: {
        onClickaway,
    },
    data() {
        return {
            localKeyword: '',
            showSuggestions: false,
        };
    },
    computed: {
        ...mapState('search', ['keyword']),
    },
    mounted() {
        this.$nextTick(() => {
            if (this.keyword) {
                this.localKeyword = this.keyword;
            }
        });
    },
    watch: {
        keyword(newValue) {
            this.localKeyword = newValue;
        },
    },
    methods: {
        updateKeyword() {
            this.$store.dispatch('search/updateKeyword', this.localKeyword);
        },
        openSuggestions() {
            this.showSuggestions = true;
        },
        closeSuggestions() {
            this.showSuggestions = false;
        },
    },
};
</script>
